var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import { createSelector } from "reselect";
import { Organisations } from "../actions";
import { INITIAL_DATA_LIST_STATE } from "./data-list.state";
import { ReducerStateFactory } from "./state-factory.reducer";
var OrganisationsState = /** @class */ (function (_super) {
    __extends(OrganisationsState, _super);
    function OrganisationsState() {
        return _super.call(this, Organisations) || this;
    }
    Object.defineProperty(OrganisationsState.prototype, "initialState", {
        get: function () {
            return __assign({}, INITIAL_DATA_LIST_STATE, { loadingBranding: false, loadingPreferences: false, roles: {}, loadingOwn: false, selectable: [], preferences: {}, branding: {} });
        },
        enumerable: true,
        configurable: true
    });
    OrganisationsState.prototype.reducer = function (state, action) {
        if (state === void 0) { state = this.initialState; }
        switch (action.type) {
            case Organisations.REQUEST_OWN:
                return __assign({}, state, { loadingOwn: true });
            case Organisations.REQUEST_PREFERENCES:
            case Organisations.UPDATE_PREFERENCES:
                return __assign({}, state, { loadingPreferences: true });
            case Organisations.RESPONSE_SUCCESS_OWN:
                var newEntities = action.payload.reduce(function (prev, next) {
                    var _a;
                    return (__assign({}, prev, (_a = {}, _a[next.id] = next, _a)));
                }, {});
                var newIds = Array.from(new Set(state.ids.concat(Object.keys(newEntities))));
                var roles = action.payload.reduce(function (prev, next) {
                    var _a;
                    return (__assign({}, prev, (_a = {}, _a[next.id] = next.roles, _a)));
                }, {});
                return __assign({}, state, { loadingOwn: false, ids: newIds, roles: roles, entities: __assign({}, state.entities, newEntities), selectable: Object.keys(newEntities) });
            case Organisations.FAIL_UPDATE_PREFERENCES: {
                return __assign({}, state, { loadingPreferences: false });
            }
            case Organisations.SUCCESS_UPDATE_PREFERENCES:
            case Organisations.RESPONSE_SUCCESS_PREFERENCES: {
                var preferences = __assign({}, state.preferences);
                preferences[action.payload.organisationId] = action.payload;
                return __assign({}, state, { preferences: preferences, loadingPreferences: false });
            }
            case Organisations.REQUEST_BRANDING: {
                return __assign({}, state, { loadingBranding: true });
            }
            case Organisations.RESPONSE_SUCCESS_BRANDING:
            case Organisations.SUCCESS_UPDATE_BRANDING_COLORS:
            case Organisations.SUCCESS_UPDATE_BRANDING_IMAGE:
                var branding = __assign({}, state.branding);
                branding[action.payload.organisationId] = action.payload;
                return __assign({}, state, { branding: branding, loadingBranding: false });
            case Organisations.RESPONSE_FAIL_BRANDING:
                return __assign({}, state, { loadingBranding: false });
        }
        return _super.prototype.reducer.call(this, state, action);
    };
    return OrganisationsState;
}(ReducerStateFactory));
export var state = new OrganisationsState();
export var createSelectors = function (rootReducer) { return ({
    getPreferencesLoading: createSelector(rootReducer, function (state) { return state.loadingPreferences; }),
    getSelectableIds: createSelector(rootReducer, function (state) { return state.selectable; }),
    getSelectable: createSelector(rootReducer, function (state) {
        return state.selectable
            .map(function (id) { return state.entities[id]; })
            .filter(function (org) { return org.enabled; });
    }),
    currentOrgPreferences: createSelector(rootReducer, function (state) { return state.preferences[state.selectedId]; }),
    currentOrgBranding: createSelector(rootReducer, function (state) { return state.branding[state.selectedId]; }),
    currentOrgRoles: createSelector(rootReducer, function (state) {
        return state.roles[state.selectedId] || [];
    })
}); };
export function reducer() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return state.reducer.apply(state, args);
}
